import { render, staticRenderFns } from "./AcryProForgotPassword.vue?vue&type=template&id=1f9fba8e&scoped=true"
import script from "./AcryProForgotPassword.vue?vue&type=script&lang=js"
export * from "./AcryProForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./AcryProForgotPassword.vue?vue&type=style&index=0&id=1f9fba8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9fba8e",
  null
  
)

export default component.exports